import React from 'react';
import { Reveal } from '../Reveal';
import { DownloadIcon } from 'lucide-react';
import { cvHref, profile, socialLinks } from '../../data/profile';
import { trackEvent } from '../../utils/analytics';
export function ContactCTA() {
  return <section id="contact" className="mt-28 scroll-mt-24 lg:scroll-mt-10" data-id="element-238" data-mp="3pnfjfvfudar6">
      <Reveal data-id="element-239" data-mp="3kumd534q5ucz">
        <div className="rounded-3xl bg-ink px-6 py-12 text-white md:px-12 md:py-16" data-id="element-240" data-mp="3ktuvkw7ypx5p">
          <h2 className="max-w-lg text-3xl font-semibold leading-tight tracking-tight md:text-[40px]" data-id="element-241" data-mp="3dmn4z65w8c6">
            Have a product people start but don't finish?
          </h2>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-white/75" data-id="element-242" data-mp="cfvytsd627r5">
            I'm open to senior product design roles and projects in fintech, AI and SaaS.
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-id="element-243" data-mp="2e6plt0phhr96">
            <a href={`mailto:${profile.email}`} onClick={() => trackEvent('email_click', {
            source: 'contact_cta'
          })} className="rounded-full bg-white px-5 py-2.5 text-sm font-medium text-ink transition-transform duration-150 ease-out hover:-translate-y-px active:scale-[0.97]" data-id="element-244" data-mp="2e79087fxdxig">
              Email me
            </a>
            <a href={cvHref} target={profile.cv ? '_blank' : undefined} rel="noreferrer" onClick={() => trackEvent('cv_download', {
            source: 'contact_cta'
          })} className="inline-flex items-center gap-2 rounded-full border border-white/30 px-5 py-2.5 text-sm font-medium text-white transition-[border-color,transform] duration-150 ease-out hover:border-white/70 active:scale-[0.97]" data-id="element-245" data-mp="3ige6nta0cobv">
              <DownloadIcon className="h-4 w-4" aria-hidden data-id="element-246" data-mp="a1dr1yryf851" />
              Download CV
            </a>
            {socialLinks.filter(l => l.label !== 'Medium').map(link => <a key={link.label} href={link.href} target="_blank" rel="noreferrer" className="rounded-full border border-white/30 px-5 py-2.5 text-sm font-medium text-white transition-[border-color,transform] duration-150 ease-out hover:border-white/70 active:scale-[0.97]" data-id="element-247" data-mp="2bsh4swx552tt">
                  {link.label}
                </a>)}
          </div>
        </div>
      </Reveal>
    </section>;
}